import { API } from "../APIs";
import { Pagination, Tokens } from "../Interfaces/Interfaces";
import { TokenValidator } from "./TokenValidator";
export default class CoordinatorService {

  tokens: any | Tokens;
  get = API.coordinator + 'get/';
  post = API.coordinator + 'post/';
  put = API.coordinator + 'put/';
  transfer = API.fundsTransfer + "post/";
  transferWallet = API.transfers + "post/";

  constructor() {
    this.tokens = TokenValidator();
  }

  async getPagedCoordinators(data: Pagination) {

    try {
      let response = await fetch(this.get + `coordinator/getPaged/${data.page}/${data.pageSize}/${data.whereCondition}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.tokens.access_token}`,
          'x-api-key': `${process.env.REACT_APP_API_KEY}`
        }
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async withdrawBankCoordinator(data: any) {
    try {
      let response = await fetch(this.transfer + `FundTransfer/CashoutFromCoordinatorWallet`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.tokens.access_token}`,
          'x-api-key': `${process.env.REACT_APP_API_KEY}`
        }, body: JSON.stringify(data)
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async withdrawWalletCoordinator(data: any) {
    try {
      let response = await fetch(this.transferWallet + `Transfer/fromcoordinatorcommission`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.tokens.access_token}`,
          'x-api-key': `${process.env.REACT_APP_API_KEY}`
        }, body: JSON.stringify(data)
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async getCoordinatorCommissionDashboard() {
    try {
      let response = await fetch(this.get + `coordinator/dashboard`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.tokens.access_token}`,
          'x-api-key': `${process.env.REACT_APP_API_KEY}`
        }
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async queryPagedCoordinators(data: Pagination) {
    try {
      let response = await fetch(this.get + `coordinator/queryPaged/${data.page}/${data.pageSize}/${data.whereCondition}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.tokens.access_token}`,
          'x-api-key': `${process.env.REACT_APP_API_KEY}`
        }
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getCoordinatorCommissions(data: Pagination) {
    try {
      let response = await fetch(this.get + `commission/${data.id}/count/${data.page}/${data.pageSize}/${data.whereCondition}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.tokens.access_token}`,
          'x-api-key': `${process.env.REACT_APP_API_KEY}`
        }
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async queryCoordinatorCommissions(data: Pagination) {
    try {
      let response = await fetch(this.get + `commission/${data.id}/query/${data.page}/${data.pageSize}/${data.whereCondition}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.tokens.access_token}`,
          'x-api-key': `${process.env.REACT_APP_API_KEY}`
        }
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  // getCashoutAccount
  async getCashoutAccount(id: any) {
    try {
      let response = await fetch(this.get + `coordinator/getCashoutAccount/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.tokens.access_token}`,
          'x-api-key': `${process.env.REACT_APP_API_KEY}`
        }
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async createCashoutAccount(data: any) {
    try {
      let response = await fetch(this.post + `coordinator/createCashoutAccount`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.tokens.access_token}`,
          'x-api-key': `${process.env.REACT_APP_API_KEY}`
        }, body: JSON.stringify(data)
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async createTransactionPIN(data: any) {
    try {
      let response = await fetch(this.post + `coordinator/createPin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.tokens.access_token}`,
          'x-api-key': `${process.env.REACT_APP_API_KEY}`
        }, body: JSON.stringify(data)
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async updateTransactionPIN(data: any) {
    try {
      let response = await fetch(this.post + `coordinator/changePin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.tokens.access_token}`,
          'x-api-key': `${process.env.REACT_APP_API_KEY}`
        }, body: JSON.stringify(data)
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async resetTransactionPIN(data: any) {
    try {
      let response = await fetch(this.put + `coordinator/resetPin`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.tokens.access_token}`,
          'x-api-key': `${process.env.REACT_APP_API_KEY}`
        }, body: JSON.stringify(data)
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getCoordinatorDashboard() {
    try {
      let response = await fetch(this.get + `coordinator/dashboard`, {

        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.tokens.access_token}`,
          'x-api-key': `${process.env.REACT_APP_API_KEY}`
        }
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getcoordinatordashboard(whereCondition: any) {

    try {
      let response = await fetch(this.get + `Coordinator/dashboard/transactions/${whereCondition}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.tokens.access_token}`,
          'x-api-key': `${process.env.REACT_APP_API_KEY}`
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async getcoordinatordashboardAgents(whereCondition: any) {

    try {
      let response = await fetch(this.get + `Coordinator/dashboard/agents/${whereCondition}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.tokens.access_token}`,
          'x-api-key': `${process.env.REACT_APP_API_KEY}`
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async getcoordinatordashboardEarnings(whereCondition: any) {

    try {
      let response = await fetch(this.get + `Coordinator/dashboard/earnings/${whereCondition}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.tokens.access_token}`,
          'x-api-key': `${process.env.REACT_APP_API_KEY}`
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async getcoordinatorPerformanceTerget(whereCondition: any) {

    try {
      let response = await fetch(this.get + `Coordinator/GetPerformanceTarget/${whereCondition}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.tokens.access_token}`,
          'x-api-key': `${process.env.REACT_APP_API_KEY}`
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

}
